const defaultMoves: MoveType[] = [];

export default defaultMoves;
